var s=class extends Error{constructor(e,i){super(e),this.invalidReason=i}};export{s as a};
//# sourceMappingURL=chunk-LG7RJQ57.mjs.map